<template>
  <div style="padding-right:15px">
  <v-layout wrap v-if="meteoData" 
    class="totem-meteo"
    :style="{ fontFamily: 'Roboto', color: color}"
  >
    <v-flex xs5>
      <v-img :src="meteoData.icon" style="height:50px;width:50px;margin-right:0;"/>
    </v-flex>
    <v-flex xs4 style="padding-top: 5px;text-align:left;font-size:1.9rem;text-align:center;">
      <b>
        {{meteoData.max}}°
      </b>
    </v-flex>
    <v-flex xs3 style="padding-top: 7px;text-align:left;font-size: 1.5rem;opacity:0.5">
      <b>
        {{meteoData.min}}°
      </b>
    </v-flex>
  </v-layout>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    meteoID: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    meteoData: null,
    timeToGoToMain: 3600,
  }),
  computed: {
    queryIcon () {
      return this.$route.query.sicon ? `${this.$route.query.sicon}` : '22'
    },
    isDev () {
      return process.env.VUE_APP_ENV === 'development'
    },
  },
  mounted () {
    this.startTimer()
    this.getData()
  }, 
  methods: {
    startTimer () {
      this.timer = window.setInterval(() => {
        this.getData()
      }, this.timeToGoToMain * 1000)
    },
    stopTimer() {
      clearInterval(timer)
    },
    getData () {
      axios.get('https://widgets.dviewcontent.com/Meteo/api/?ID=' + this.meteoID)
        .then(response => {
          const aux = response.data.shift()
          
          this.meteoData = !aux ? null : {
            icon: aux.Icono.replace('imagenesmeteo/', `imagenesmeteo${this.queryIcon}/`),
            max: aux.Max,
            min: aux.Min,
          }
        })
    }
  }
}
</script>
<style scoped>
.totem-meteo {
  margin-top:25px;
  padding: 0 15px 5px 10px;
  color:white;
  font-size:2rem;
  background-color: #0000001A;
  border-radius: 40px;

}
</style>

